// 创建 pdf.js
// 引入依赖
import Vue from 'vue';
import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
function dataURLtoBlob(dataurl) {
    const arr = dataurl.split(',');
    //注意base64的最后面中括号和引号是不转译的
    const _arr = arr[1].substring(0,arr[1].length-2);
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(_arr);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
        type: mime
    });
}
// blob转file
const blobToFile = function(newBlob, fileName) {
    newBlob.lastModifiedDate = new Date();
    newBlob.name = fileName;
    return newBlob;
};
Vue.prototype.$createPdf = function (targetDom, name, callback) {
    const scale = 4;
    const cloneDom = targetDom.cloneNode(true);
    cloneDom.style.width = targetDom.scrollWidth + 'px';
    cloneDom.style.height = targetDom.scrollHeight + 'px';
    cloneDom.style.background = '#FFFFFF';
    document.body.appendChild(cloneDom);
    html2canvas(cloneDom, {
        scale: scale, // 提升画面质量，但是会增加文件大小
        useCORS: true, // 允许跨域图片 当图片是链接地址时，需加该属性，否组无法显示图片
        imageTimeout: 0, // 图片加载延迟，默认延迟为0，单位毫秒
        height: targetDom.scrollHeight, // canvas的高度设定
        width: targetDom.scrollWidth, // canvas的宽度设定
        dpi: window.devicePixelRatio * 96, // 将分辨率提高到特定的DPI
    }).then(canvas => {
        document.body.removeChild(cloneDom);
        // a4纸的尺寸[592.28,841.89]
        const A4_WIDTH = 592.28;
        const A4_HEIGHT = 841.89;
        const contentWidth = canvas.width;
        const contentHeight = canvas.height;
        const ctx=canvas.getContext('2d');
        ctx.scale(200,200);
        const pageData = canvas.toDataURL('image/jpeg', 1.0);
        // 一页pdf html页面生成的canvas高度;
        const pageHeight = contentWidth / A4_WIDTH * A4_HEIGHT;
        // 未生成pdf的html页面高度
        let leftHeight = contentHeight;
        // 页面偏移
        let position = 0;
        // a4纸的尺寸[592.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        const imgWidth = A4_WIDTH;
        const imgHeight = A4_WIDTH / contentWidth * contentHeight;
        // 设置pdf的尺寸，pdf要使用pt单位 已知 1pt/1px = 0.75   pt = (px/scale)* 0.75
        const pdf = new JsPDF('', 'pt', 'a4');
        // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度
        // 当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
            pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        } else {
            while (leftHeight > 0) {
                pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
                leftHeight -= pageHeight;
                position -= A4_HEIGHT;
                // 避免添加空白页
                if (leftHeight > 0) {
                    pdf.addPage();
                }
            }
        }
        // 直接下载
        // pdf.save(name + '.pdf')
        // base64转成文件
        const buffer = pdf.output('datauristring');
        const blob = dataURLtoBlob(buffer);
        const file = blobToFile(blob);
        callback(file, buffer, canvas);
    });
};
// export default {
//     install(Vue) {
//         // Vue.prototype.$getPDF = function(domClass, review = false, download = false, title = `sf_${new Date().getTime()}`) {
//         //     const element = document.querySelector(domClass); // 这个dom元素是要导出pdf的div容器
//         //     html2Canvas(element).then(function(canvas) {
//         //         let pdf;
//         //         const offsetHeight = 841.89;
//         //         const contentWidth = canvas.width;
//         //         const contentHeight = canvas.height;
//         //         const imgWidth = 555.28;
//         //         const imgHeight = 592.28 / contentWidth * contentHeight;
//         //         const pageData = canvas.toDataURL('image/jpeg', 1.0);
//         //         const setPDF = () => {
//         //             const pageHeight = contentWidth / 592.28 * offsetHeight;
//         //             let leftHeight = contentHeight;
//         //             let position = 0;
//         //             pdf = new JsPDF('', 'pt', 'a4'); //不分页
//         //
//         //             if (leftHeight < pageHeight) {
//         //                 pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight + 20);
//         //             } else {
//         //                 while (leftHeight > 0) {
//         //                     pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight + 16);
//         //                     leftHeight -= pageHeight;
//         //                     position -= offsetHeight;
//         //                     //避免添加空白页
//         //                     if (leftHeight > 0) {
//         //                         pdf.addPage();
//         //                         // const pageSize = pdf.getNumberOfPages();
//         //                         // const pageWidth = Math.floor(pdf.internal.pageSize.width || pdf.internal.pageSize.getWidth());
//         //                         // const pageHeight = Math.floor(pdf.internal.pageSize.height || pdf.internal.pageSize.getHeight());
//         //                         // for (let page = 1;page < pageSize;++page) {
//         //                         //     pdf.setPage(page);
//         //                         //     pdf.line(25, pageHeight - 10, pageWidth - 25, pageHeight - 10);
//         //                         //     pdf.text('---', 40, pageHeight - 5);
//         //                         // }
//         //                     }
//         //                 }
//         //             }
//         //             // pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
//         //         };
//         //
//         //         if (review) {
//         //             setPDF();
//         //             window.open(URL.createObjectURL(dataURLtoBlob(pdf.output('datauristring'))));
//         //         }else if (download) {
//         //             setPDF();
//         //             pdf.save(title + '.pdf');
//         //         } else {
//         //             Print({
//         //                 printable: pageData,
//         //                 type: 'image',
//         //                 documentTitle: title
//         //             });
//         //         }
//         //     });
//         // };
//         Vue.prototype.$getPDF = function (el, title = `SF_${new Date().getTime()}`, isPrint = false) {
//             const dom = document.querySelector(el);
//
//             html2canvas(dom, {
//                 allowTaint: true, useCORS: true, dpi: 120, //图片清晰度问题
//                 background: '#FFFFFF', //如果指定的div没有设置背景色会默认成黑色,这里是个坑
//             }).then(canvas => { //未生成pdf的html页面高度
//                 let leftHeight = canvas.height;
//                 const a4Width = 595.28;
//                 const a4Height = 841.89; //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
//                 //一页pdf显示html页面生成的canvas高度; 
//                 const a4HeightRef = Math.floor((canvas.width / a4Width) * a4Height); //pdf页面偏移
//                 let position = 0;
//                 const pageData = canvas.toDataURL('image/jpeg', 1.0);
//
//                 const pdf = new jsPDF('p', 'pt', 'a4'); //A4纸，纵向
//                 const canvas1 = document.createElement('canvas');
//                 let index = 1, height;
//                 pdf.setDisplayMode('fullwidth', 'continuous', 'FullScreen');
//                 const pdfName = title;
//
//                 function createImpl(canvas) {
//                     if (leftHeight > 0) {
//                         index++;
//                         let checkCount = 0;
//                         if (leftHeight > a4HeightRef) {
//                             let i = position + a4HeightRef;
//                             for (i = position + a4HeightRef; i >= position; i--) {
//                                 let isWrite = true;
//                                 for (let j = 0; j < canvas.width; j++) {
//                                     const c = canvas.getContext('2d').getImageData(j, i, 1, 1).data;
//                                     if (c[0] !== 0xff || c[1] !== 0xff || c[2] !== 0xff) {
//                                         isWrite = false;
//                                         break;
//                                     }
//                                 }
//                                 if (isWrite) {
//                                     checkCount++;
//                                     if (checkCount >= 10) {
//                                         break;
//                                     }
//                                 } else {
//                                     checkCount = 0;
//                                 }
//                             }
//                             height = Math.round(i - position) || Math.min(leftHeight, a4HeightRef);
//                             if (height <= 0) {
//                                 height = a4HeightRef;
//                             }
//                         } else {
//                             height = leftHeight;
//                         }
//                         canvas1.width = canvas.width;
//                         canvas1.height = height;
//                         const ctx = canvas1.getContext('2d');
//                         ctx.drawImage(canvas, 0, position, canvas.width, height, 0, 0, canvas.width, height,);
//                         const pageHeight = Math.round((a4Width / canvas.width) * height); // pdf.setPageSize(null, pageHeight)
//                         if (position !== 0) {
//                             pdf.addPage();
//                         }
//                         pdf.addImage(canvas1.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 10, a4Width, (a4Width / canvas1.width) * height,);
//                         leftHeight -= height;
//                         position += height;
//                         if (leftHeight > 0) {
//                             setTimeout(createImpl, 500, canvas);
//                         } else {
//                             if (isPrint) {
//                                 Print({
//                                     printable: canvas.toDataURL('image/jpeg', 1.0),
//                                     type: 'image',
//                                     documentTitle: title,
//                                 });
//                             }else {
//                                 window.open(URL.createObjectURL(dataURLtoBlob(pdf.output('datauristring'))));
//                             }
//                         }
//                     }
//                 } //当内容未超过pdf一页显示的范围，无需分页
//                 if (leftHeight < a4HeightRef) {
//                     pdf.addImage(pageData, 'JPEG', 0, 0, a4Width, (a4Width / canvas.width) * leftHeight + 20,);
//                     // pdf.save(pdfName + '.pdf');
//                     if (isPrint) {
//                         Print({
//                             printable: canvas.toDataURL('image/jpeg', 1.0),
//                             type: 'image',
//                             documentTitle: title,
//                         });
//                     }else {
//                         window.open(URL.createObjectURL(dataURLtoBlob(pdf.output('datauristring'))));
//                     }
//                 } else {
//                     try {
//                         pdf.deletePage(0);
//                         setTimeout(createImpl, 500, canvas);
//                     } catch (err) {
//                         throw new Error(`生成pdf出错: ${err}`);
//                     }
//                 }
//             });
//         };
//     }
// };
